export default __webpack_public_path__ + "static/media/close-icon.2fb7add8.svg";